import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';

const ConfirmDeleteModal = props => {
  return (
        <Modal isOpen={props.isOpen}
        toggle={props.toggle()}
        style={{fontSize: '0.85rem'}}
        centered>
            <ModalHeader toggle={props.toggle()}>{props.action.charAt(0).toUpperCase() + props.action.slice(1)}</ModalHeader>
            <ModalBody>Are you sure you want to {props.action} this {props.name} ?</ModalBody>
            <ModalFooter>
                <Button
                color="link"
                    className="theme-button theme-button-secondary"
                    onClick={props.toggle()}
                >
                    Cancel
                </Button>
                <Button color="link" className="theme-button theme-button-primary" onClick={() => props.actionFunc()}>
                    Yes, {props.action} it
                </Button>
            </ModalFooter>
        </Modal>
  );
};

export default ConfirmDeleteModal;
